import { render, staticRenderFns } from "./DomainSelect.vue?vue&type=template&id=45b21d24&"
import script from "./DomainSelect.vue?vue&type=script&lang=js&"
export * from "./DomainSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b21d24')) {
      api.createRecord('45b21d24', component.options)
    } else {
      api.reload('45b21d24', component.options)
    }
    module.hot.accept("./DomainSelect.vue?vue&type=template&id=45b21d24&", function () {
      api.rerender('45b21d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/DomainSelect.vue"
export default component.exports